import MarkdownShow from './MarkdownShow.vue'
const markdownShow = {
	install: function(Vue) {
		Vue.component('MarkdownShow', MarkdownShow)
	}
}
export default markdownShow
